import { apiSlice } from "app/api/apiSlice"


export const healtEventApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        // ALL EVENTS
        getAllHealthEvents: builder.query({
            query: ({ start, end, userGuid = null }) => {
                return {
                    url: 'health/data/events',
                    method: 'GET',
                    params: userGuid ? {
                        start: start,
                        end: end,
                        userGuid: userGuid
                    } : {
                        start: start,
                        end: end
                    }
                }
            },
            keepUnusedDataFor: 5,
        }),

        getHealthStats: builder.query({
            query: (days) => {
                return {
                    url: 'health/stats',
                    method: 'GET',
                    params: {days}
                }
            },
            keepUnusedDataFor: 5,
        })
    })
})

export const {
    useGetAllHealthEventsQuery,
    useLazyGetAllHealthEventsQuery,
    useGetHealthStatsQuery
} = healtEventApiSlice